export default __webpack_public_path__ + "static/media/1339.726e4fe4.png";